import { render, staticRenderFns } from "./ProfileSettingEducation.vue?vue&type=template&id=d85450ca&"
import script from "./ProfileSettingEducation.vue?vue&type=script&lang=js&"
export * from "./ProfileSettingEducation.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettingEducation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports